import httpClient from '@/http-client'

export const employees = data =>
    httpClient
        .get('/api/reports/cash-transfer-reports/employees', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))

export const banks = data =>
    httpClient
        .get('/api/reports/cash-transfer-reports/banks', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))

export const currencies = data =>
    httpClient
        .get('/api/reports/cash-transfer-reports/currencies', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))

export const index = data =>
    httpClient
        .get('/api/reports/cash-transfer-reports', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))

export const pdf = data =>
    httpClient
        .get('/api/reports/cash-transfer-reports/pdf', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))

export const exportExcel = data =>
    httpClient
        .post('/api/reports/cash-transfer-reports/excel', data, {
            responseType: 'arraybuffer'
        })
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))

export default { employees, banks, currencies, index, pdf, exportExcel }
